﻿import {Utils} from "../../Utils/Utils";
import {Core} from "../../Base/Core";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {UISprite} from "../Tools/Base/UISprite";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {isIOS} from "../../../dpCommonPortHelper";

class AdsMoneyButton extends UINineSlice {
    constructor() {
        super("btn-blue");
        this.interactive = true;
        this.cursor = "pointer";
    }

    Awake() {
        super.Awake();
        this.rewardField = this.addChild(
            new UILabeledIcon({
                label: "",
                icon: "ico-diamond",
                iconAlign: "right",
                iconSize: 0.9
            })
        );
        this.picture = this.addChild(new UISprite("bank/pack-gems-handful"));

        this.btnBack = this.addChild(new UINineSlice("bg-simple"));
        this.btnBack.alpha = 0.3;

        this.btn = this.addChild(
            new UILabeledIcon({
                label: Core.Localizator.Get("free"),
                icon: "play-icon",
                iconAlign: "right",
                iconSize: 0.7
            })
        );
    }

    Init() {
        this.rewardField.label = Utils.Format(
            "+{0}",
            Core.GameData.AppStore.hardAdsBonusReward.value
        );
    }

    fitLayout(rect) {
        super.fitLayout(rect);

        let rewardRect = rect.clone();
        rewardRect.width = rect.width * 0.7;
        rewardRect.height = rect.height * 0.15;
        rewardRect.x = (rect.width - rewardRect.width) * 0.5;
        rewardRect.y = (rect.height - rewardRect.height) * 0.08;
        this.rewardField.fitLayout(rewardRect);

        let spriteRect = rect.clone();
        spriteRect.width = rect.width * 0.8;
        spriteRect.height = rect.height * 0.45;
        spriteRect.x = (rect.width - spriteRect.width) * 0.5;
        spriteRect.y = (rect.height - spriteRect.height) * 0.42;
        this.picture.fitRect(spriteRect, true);

        let btnRect = rect.clone();
        btnRect.width = rect.width * 0.65;
        btnRect.height = rect.height * 0.15;
        btnRect.x = (rect.width - btnRect.width) * 0.5;
        btnRect.y = (rect.height - btnRect.height) * 0.85;
        this.btnBack.fitLayout(btnRect);

        btnRect.pad(-btnRect.height * 0.1);
        this.btn.fitLayout(btnRect);
    }
}

class BuyMoneyButton extends UINineSlice {
    constructor() {
        super("btn-orange");
        this.interactive = true;
        this.cursor = "pointer";
    }

    Awake() {
        super.Awake();
        this.rewardField = this.addChild(
            new UILabeledIcon({
                label: "",
                icon: "ico-diamond",
                iconAlign: "right",
                iconSize: 0.9
            })
        );
        this.picture = this.addChild(new UISprite("bank/pack-gems-sack"));

        this.btnBack = this.addChild(new UINineSlice("bg-simple"));
        this.btnBack.alpha = 0.3;

        this.btn = this.addChild(new UILabeledIcon({label: ""}));
    }

    Init() {
        if (!Core.Store.ProductAvailable("hard2")) return;
        let product = Core.Store.GetProduct("hard2");
        let reward = product.rewards[0];
        this.rewardField.label = reward.realValue;
        this.btn.label = product.GetPrice();
    }

    fitLayout(rect) {
        super.fitLayout(rect);

        let rewardRect = rect.clone();
        rewardRect.width = rect.width * 0.7;
        rewardRect.height = rect.height * 0.15;
        rewardRect.x = (rect.width - rewardRect.width) * 0.5;
        rewardRect.y = (rect.height - rewardRect.height) * 0.08;
        this.rewardField.fitLayout(rewardRect);

        let spriteRect = rect.clone();
        spriteRect.width = rect.width * 0.8;
        spriteRect.height = rect.height * 0.45;
        spriteRect.x = (rect.width - spriteRect.width) * 0.5;
        spriteRect.y = (rect.height - spriteRect.height) * 0.42;
        this.picture.fitRect(spriteRect, true);

        let btnRect = rect.clone();
        btnRect.width = rect.width * 0.65;
        btnRect.height = rect.height * 0.15;
        btnRect.x = (rect.width - btnRect.width) * 0.5;
        btnRect.y = (rect.height - btnRect.height) * 0.85;
        this.btnBack.fitLayout(btnRect);

        btnRect.pad(-btnRect.height * 0.1);
        this.btn.fitLayout(btnRect);
    }
}

export class UINotEnoughMoney extends UICommonPopup {
    Awake() {
        super.Awake({
            title: Core.Localizator.Get("no_money", {
                fontSize: 64,
                wordWrap: true,
                wordWrapWidth: 100,
                align: "center"
            }),
            closeButton: true
        });
        this.onClickAds = this.onClickAds.bind(this);
        this.onShown = this.onShown.bind(this);

        this.adsBtn = this.content.addChild(new AdsMoneyButton());
        this.adsBtn.on("pointertap", this.onClickAds);

        if (!isIOS()) {
            this.buyBtn = this.content.addChild(new BuyMoneyButton());
            this.onClickBuy = this.onClickBuy.bind(this);
            this.buyBtn.on("pointertap", this.onClickBuy);
        }
    }

    Init() {
        super.Init();
        this.adsBtn.Init();
        if (this.buyBtn) this.buyBtn.Init();
    }

    Show() {
        this.Init();
        super.Show();
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 0.9;
        let w = Math.min(viewport.width * 0.8, (viewport.height * 0.8) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(
            new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h)
        );

        super.fitLayout(viewport);

        let popupRect = this.getContentSize();

        let buttonPaddingY = popupRect.width * 0.08;
        let buttons = [this.adsBtn, this.buyBtn].filter(btn => btn && btn.visible);

        let buttonRect = popupRect.clone();
        buttonRect.y += buttonPaddingY + this.header.height;
        buttonRect.height = buttonRect.height - buttonPaddingY * 2 - this.header.height;

        buttonRect.width = Math.min(
            buttonRect.width * 0.5,
            (buttonRect.width * 0.9) / buttons.length
        );
        let totalWidth = buttonRect.width * buttons.length;
        let buttonPaddingX = (popupRect.width - totalWidth) / (buttons.length + 1);
        buttonRect.x += buttonPaddingX;

        for (let btn of buttons) {
            btn.fitLayout(buttonRect);
            buttonRect.x += buttonRect.width + buttonPaddingX;
        }
    }

    onClickAds() {
        Core.Ads.TriggerRewarded(this.onShown);
    }

    onClickBuy() {
        Core.Store.BuyProductID("hard2");
    }

    onShown() {
        Core.GameData.AppStore.hardAdsBonusReward.Take("hard_from_ads");
    }
}
